import { gql } from "@apollo/client";

const TEAMS = gql`
  query teams($filter: ListTeamInput, $page: Int, $limit: Int) {
    teams(filter: $filter, page: $page, limit: $limit) {
      teams {
        id
        createdAt
        title
        tournamentCount
        sport {
          id
          title
          icon
        }
        club {
          id
          clubName
        }
        discipline {
          id
          title
        }
        joinedFrom
        country
        status
        phone
        email
        website
        instagramLink
        facebookLink
        twitterLink
        tiktokLink
        image
        members {
          member {
            name
            id
            email
            avatar
            surname
            nation
          }
          team {
            title
          }
          role
        }
      }
      total
    }
  }
`;

export default TEAMS;
